"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API_FULL = exports.API_VERSION = exports.API_URL = void 0;
var HREF = window.location.href;
var url = "";

switch (true) {
  case HREF.search("localhost") !== -1 || HREF.search("test") !== -1:
    // test or localhost
    url = "https://test-quotation.iconnectance.com";
    break;

  case HREF.search("uat") !== -1:
    // uat
    url = "https://uat-quotation-api.aseguradoraabank.com";
    break;

  default:
    // portal
    url = "https://quotation.iconnectance.com";
    break;
}

var API_URL = url;
exports.API_URL = API_URL;
var API_VERSION = "v1";
exports.API_VERSION = API_VERSION;
var API_FULL = "".concat(API_URL, "/").concat(API_VERSION);
exports.API_FULL = API_FULL;